
// CUSTOM_CODE

(function () {
  let loading = false;
  let lastTerm = "";

  customElements.whenDefined("predictive-search").then(() => {
    const Predictive = customElements.get("predictive-search");
    if (!Predictive || Predictive.prototype.__metafieldSearchPatched) return;

    const originalRender = Predictive.prototype.renderSearchResults;

    Predictive.prototype.renderSearchResults = function (resultsMarkup) {
      originalRender.call(this, resultsMarkup);

      const term = this.getQuery ? this.getQuery().trim() : "";
      if (term.length >= 3) {
        runMetafieldSearch(term);
      }
    };

    Predictive.prototype.__metafieldSearchPatched = true;
  });

async function runMetafieldSearch(rawTerm) {
  const container = document.getElementById("models-search-results");
  if (!container) return;

  if (!rawTerm || rawTerm.length < 2) {
    container.innerHTML = "";
    return;
  }

  const term = normalize(rawTerm);

  container.innerHTML = `
    <div class="p-3 text-sm opacity-70">Sto cercando prodotti compatibili...</div>
  `;

  try {
    const token = window.__sfToken;
    let allProducts = [];
    let hasNextPage = true;
    let cursor = null;

    // 1️⃣ PAGINAZIONE (max 1000 prodotti)
    while (hasNextPage && allProducts.length < 1000) {
      const query = `
        query getProducts($cursor: String) {
          products(first: 250, after: $cursor, sortKey: TITLE) {
            edges {
              cursor
              node {
                title
                handle
                vendor
                featuredImage { url }
                priceRange {
                  minVariantPrice { amount currencyCode }
                }
                metafield(namespace: "custom", key: "modelli_compatibili") {
                  value
                }
              }
            }
            pageInfo {
              hasNextPage
            }
          }
        }
      `;

      const res = await fetch("/api/2024-07/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": token
        },
        body: JSON.stringify({ query, variables: { cursor } })
      });

      const json = await res.json();

      const { edges, pageInfo } = json.data.products;
      allProducts = allProducts.concat(edges.map(e => e.node));

      hasNextPage = pageInfo.hasNextPage;
      cursor = edges.length ? edges[edges.length - 1].cursor : null;
    }

    // 2️⃣ FILTRO: prodotti con metafield
    const withMf = allProducts.filter(p => p.metafield?.value);

    // 3️⃣ NORMALIZZA i valori del metafield (JSON o stringa)
    const results = withMf.filter(p => {
      const raw = p.metafield.value;
      const normalized = normalize(raw);
      return normalized.includes(term);
    });

    // 4️⃣ PRIMI 10
    const top10 = results.slice(0, 10);

    if (!top10.length) {
      container.innerHTML = `
        <div class="p-3 text-sm opacity-70">Nessun prodotto compatibile trovato.</div>
      `;
      return;
    }

    // 5️⃣ HTML SIMILE AL TUO SCREENSHOT
    let html = `<div class="compat-list">`;

    top10.forEach((p) => {
      const img = p.featuredImage?.url || "//cdn.shopify.com/s/files/no-image.png";
      const price = `${p.priceRange.minVariantPrice.amount} ${p.priceRange.minVariantPrice.currencyCode}`;
      const vendor = p.vendor || "";

      html += `
        <a href="/products/${p.handle}" class="compat-item">
          <div class="compat-thumb-wrapper">
            <img src="${img}" class="compat-thumb" loading="lazy" />
          </div>
          <div class="compat-info">
            <div class="compat-vendor">${vendor}</div>
            <div class="compat-title">${p.title}</div>
            <div class="compat-price">€${p.priceRange.minVariantPrice.amount}</div>
          </div>
        </a>
      `;
    });

    html += `</div>`;

    container.innerHTML = html;

  } catch (err) {
    console.error("Errore ricerca metafield:", err);
    container.innerHTML =
      `<div class="p-3 text-red-600 text-sm">Errore nella ricerca.</div>`;
  }
}


})();



function normalize(value) {
  return value
    .toLowerCase()
    .normalize("NFD")               // rimuove accenti
    .replace(/[\u0300-\u036f]/g, "") 
    .replace(/[^a-z0-9]/gi, "")    // togli tutto tranne lettere/numeri
    .trim();
}
